import { useState } from "react";
import SolarScene from "./SolarScene";
import { useSite } from "@/context/SiteContext";

const GOALS = [
  { id: "Backup essentials", copy: "Choose your backup priorities, then request a system review matched to your property." },
  { id: "Use more solar", copy: "Store some daytime solar for later use. The value depends on your tariff, consumption and system design." },
  { id: "Commercial storage review", copy: "For larger or three-phase facilities, request an engineered commercial storage review. Powerwall is offered only after compatibility is confirmed." },
];

export default function StorageSection({ onPlanStorage = null }) {
  const { openLead } = useSite();
  const [goal, setGoal] = useState("Backup essentials");
  const [units, setUnits] = useState(2);
  const active = GOALS.find((g) => g.id === goal);

  return (
    <div className="storage-grid" data-testid="storage-section">
      <div>
        <span className="eyebrow">03 / MAKE YOUR SOLAR GO FURTHER</span>
        <h2>
          Make room for
          <br />
          power after sunset.
        </h2>
        <p>
          Explore Tesla Powerwall for compatible properties. Store solar energy for later and build a backup plan around the circuits that matter most.
        </p>
        <div className="storage-actions" role="group" aria-label="Storage goal">
          {GOALS.map((g) => (
            <button key={g.id} className={`chip ${goal === g.id ? "active" : ""}`} data-goal={g.id} aria-pressed={goal === g.id} data-testid={`storage-goal-${g.id.split(" ")[0].toLowerCase()}`} onClick={() => setGoal(g.id)}>
              {g.id}
            </button>
          ))}
        </div>
        <p data-testid="storage-guidance">{active.copy}</p>
        <label className="battery-options">
          Explore units
          <input type="range" value={units} min={1} max={4} data-testid="storage-units" onChange={(e) => setUnits(Number(e.target.value))} />
          <b data-testid="unit-count">{units}</b>
        </label>
        <button
          className="btn lime"
          data-testid="storage-cta"
          onClick={() => {
            if (onPlanStorage) { onPlanStorage(); return; }
            openLead(
              goal === "Commercial storage review" ? "commercial" : "powerwall",
              goal === "Commercial storage review" ? "Commercial storage review" : "Tesla Powerwall / storage assessment",
              { storageInterest: { goal, units }, audience: goal === "Commercial storage review" ? "business" : "home" },
            );
          }}
        >
          Add storage to my plan <span>↗</span>
        </button>
        <p style={{ fontSize: 10, marginTop: 17 }}>
          Product and system selection depend on electrical service, load, site conditions and availability. Larger commercial facilities need a separate storage design.
        </p>
      </div>
      <div className="battery-room">
        <div className="scene-label" style={{ color: "#d2e4d9" }}>
          TESLA POWERWALL · STYLIZED PRODUCT CONCEPT
        </div>
        <SolarScene kind={goal === "Commercial storage review" ? "commercial-storage" : "powerwall"} state={{ batteries: units }} testId="storage-scene" />
        <div className="floating two">
          <span>SMARTER TOGETHER</span>
          <strong>Generate. Store. Use.</strong>
        </div>
      </div>
    </div>
  );
}
